window.addEventListener("load", () => {
    const virtualTourPanels = document.querySelectorAll(".virtual-tour-panel");

    for (const panel of virtualTourPanels) {
        const hasValidCards = panel.querySelector("[data-vt-card]");

        if (hasValidCards) {
            panel.addEventListener("click", (event) => {
                const button = event.target.closest("div[data-vt-card]");

                if (!button) return;

                // Check if the current media breakpoint is 1023px or less
                if (window.matchMedia("(max-width: 1023px)").matches) {
                    const siteHeader = document.querySelector("#siteHeader");

                    if (siteHeader) {
                        const headerHeight = siteHeader.offsetHeight;

                        // Scroll to the top of the .virtual-tour-panel + headerHeight
                        const panelTop = panel.getBoundingClientRect().top + window.scrollY;
                        window.scrollTo({
                            top: panelTop - headerHeight,
                            behavior: "smooth",
                        });
                    }
                }

                // Map button data attributes to the target elements
                const mappings = {
                    "data-tour-link": "[data-vt-iframe]",
                };

                // Update elements based on mappings
                Object.entries(mappings).forEach(([buttonAttr, targetSelector]) => {
                    const targetElement = panel.querySelector(targetSelector);
                    const value = button.getAttribute(buttonAttr);

                    if (!targetElement || value === null) return;

                    if (targetSelector === "[data-vt-iframe]") {
                        targetElement.setAttribute("src", value); // Changes src and reloads iframe
                    }
                });

                // Update button states
                panel.querySelectorAll("div[data-vt-card]").forEach((btn) => {
                    btn.setAttribute("data-active", btn === button ? "true" : "false");
                });
            });
        }
    }
});